/**
 * /frontend/src/features/analytics/components/queue/ServiceTimeBySection.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import ComparisonBarChart from '../charts/ComparisonBarChart';
import { CHART_COLORS } from '../../constants/chartColors';
import { toServiceTimeBySectionSeries } from '../../utils/chartDataTransformers';
import { formatMinutes } from '../../utils/formatters';

/**
 * Average service time by section chart.
 * @param {{performance:any}} props
 * @returns {JSX.Element}
 */
const ServiceTimeBySection = ({ performance }) => {
  const data = useMemo(() => toServiceTimeBySectionSeries(performance), [performance]);
  return (
    <ChartContainer title="Service Time by Section" subtitle="Average service time (activated to completed)">
      <ComparisonBarChart
        data={data}
        xKey="sectionName"
        yKey="avgServiceMinutes"
        color={CHART_COLORS.accentStrong}
        yFormatter={(v) => formatMinutes(v)}
      />
    </ChartContainer>
  );
};

export default ServiceTimeBySection;

